/**
 * Reading the session. Its own file so that `AuthProvider.tsx` exports only a
 * component, which is what keeps fast refresh working on it.
 */
import { useContext } from 'react';
import { AuthContext, type AuthContextValue } from './AuthProvider';

export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used inside <AuthProvider>.');
  }
  return context;
}
